<template>
  <div>
    <div class="mine-hero">
      <div class="mine-hero-ttl">⛏️ {{ ui.heroTitle }}</div>
      <div class="mine-hero-sub">{{ ui.heroSubtitle }}</div>
    </div>

    <div class="sec">
      <HeroVideo :src="video.src" :poster="video.poster" :caption="ui.videoCaption" />
    </div>

    <div class="sec">
      <div class="sec-hd">全网数据</div>
      <div class="gstats gstats-market">
        <div class="gs market-price-card">
          <div style="display: flex; align-items: center; gap: 8px">
            <span style="font-size: 16px">💎</span>
            <span style="font-size: 12px; color: var(--muted)">{{ ui.globalPriceLabel }}</span>
          </div>
          <div style="text-align: right">
            <span class="num-orbitron" style="font-size: 18px; font-weight: 900; color: var(--gold)">${{ configInfo.tokenPrice || '--' }}</span>
          </div>
        </div>
        <div class="gs gs-global"><div class="gs-v">{{ configInfo.accToken || '--' }}</div><div class="gs-l">全网燃烧金狗人生</div></div>
        <div class="gs gs-global"><div class="gs-v">{{ configInfo.totalReward || '--' }}</div><div class="gs-l">累计分红 {{ chainSymbol }}</div></div>
      </div>
    </div>

    <div class="sec">
      <div class="daily-row daily-row-market">
        <div class="ds ds-market">
          <div class="ds-l">🔥 今日燃烧</div>
          <div class="ds-v">{{ configInfo.todayAccToken || '--' }}</div>
          <div class="ds-u">{{ configInfo.tokenSymbol || '金狗人生' }}</div>
        </div>
        <div class="ds ds-market">
          <div class="ds-l">💰 今日分红</div>
          <div class="ds-v">{{ configInfo.todayReward || '--' }}</div>
          <div class="ds-u">{{ chainSymbol }}</div>
        </div>
      </div>
    </div>

    <div class="sec">
      <div class="sec-hd">参与燃烧</div>
      <div class="mine-card">
        <div class="card-hdr">
          <div class="card-ttl"><span>🐕</span>{{ ui.mineCardTitle }}</div>
          <span class="tag tag-amber">{{ ui.multiplierTag }}</span>
        </div>
        <div class="mine-body">
          <div class="inp-lbl">{{ ui.inputHint }}</div>
          <div class="irow">
            <span style="font-size: 22px">🐕</span>
            <input v-model.trim="inputAmount" type="number" placeholder="0.1 / 0.2 / 1 ..." step="0.1" min="0.1" @input="handleInputValue">
            <span class="irow-unit">{{ ui.inputUnit }}</span>
          </div>

          <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 2px; margin-bottom: 10px; margin-top: -4px">
            <span style="font-size: 11px; color: var(--muted); display: flex; align-items: center; gap: 4px">
              💰 余额
              <span style="color: var(--gold); font-family: 'Orbitron', monospace; font-size: 11px; font-weight: 700">{{ displayTokenBalance }}</span>
            </span>
            <span class="pay-token-hint">需支付等值代币</span>
          </div>

          <div class="mcalc">
            <div class="mcalc-l">
              <div>预计支付</div>
              <b>{{ showTokenOut || '--' }}</b>
              <div style="font-size: 9px; color: var(--muted); margin-top: 2px">{{ configInfo.tokenSymbol || '金狗人生' }}</div>
            </div>
            <div class="mcalc-arr">→</div>
            <div class="mcalc-r">
              <div style="font-size: 10px; color: var(--muted); margin-bottom: 4px">分红额度</div>
              <b>{{ rewardOut || '--' }}</b>
              <small>{{ ui.multiplierTag }}</small>
            </div>
          </div>

          <div v-if="previewErrorText" class="calc-note">{{ previewErrorText }}</div>

          <button class="btn-mine" :disabled="burnLoading" @click="burn">{{ burnLoading ? '链上确认中...' : '参与燃烧' }}</button>
        </div>
      </div>
    </div>

    <div class="sec">
      <div class="sec-hd">个人面板</div>
      <div class="pgrid">
        <div class="pc"><div class="pc-ico">&#128202;</div><div class="pc-l">总分红额度</div><div class="pc-v">{{ userInfo.maxReward }}</div><div class="pc-u">{{ chainSymbol }}</div></div>
        <div class="pc"><div class="pc-ico">&#127974;</div><div class="pc-l">剩余额度</div><div class="pc-v">{{ userInfo.remainReward }}</div><div class="pc-u">{{ chainSymbol }}</div></div>
        <div class="pc"><div class="pc-ico">&#128101;</div><div class="pc-l">一线伙伴</div><div class="pc-v">{{ userInfo.binderLen || '--' }}</div><div class="pc-u">人</div></div>
        <div class="pc"><div class="pc-ico">&#127942;</div><div class="pc-l">协作激励</div><div class="pc-v">{{ userInfo.cooperationReward }}</div><div class="pc-u">{{ configInfo.tokenSymbol || '金狗人生' }}</div></div>
      </div>
    </div>

    <div class="sec">
      <div class="claim-row">
        <div class="claim-info">
          <div class="claim-l">待领取分红 {{ chainSymbol }}</div>
          <div class="claim-amt">{{ userInfo.pendingReward }}</div>
        </div>
        <button class="btn-claim" :disabled="claimLoading" @click="claim">{{ claimLoading ? '领取中...' : '立即领取' }}</button>
      </div>
    </div>

    <div class="sec">
      <div class="sec-hd">邀请推广</div>
      <div class="card">
        <div class="card-hdr">
          <div class="card-ttl"><span>🔗</span>我的邀请链接</div>
          <span class="tag tag-green">{{ ui.inviteTag }}</span>
        </div>
        <div class="inv-body">
          <div class="link-row">
            <span class="link-txt">{{ inviteDisplayText }}</span>
            <button class="copy-btn" :disabled="copyInviteDisabled" @click="copyInvite">复制</button>
          </div>
          <div class="inv-stats" style="margin-bottom: 0">
            <div class="ist"><div class="ist-v">{{ userInfo.teamNum || '--' }}</div><div class="ist-l">在册人数</div></div>
            <div class="ist"><div class="ist-v">{{ userInfo.teamAmount || '--' }}</div><div class="ist-l">协作贡献</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WalletState, { CHAIN_ID, CHAIN_ERROR_TIP, CHAIN_SYMBOL } from '../state/WalletState'
import { DAPP_CONFIG } from '../config/dapp'
import { getRef } from '../utils/utils'
import { copyContent } from '../utils/utools'
import { burnAction, claimAction, fetchBurnData, getInviteLink, previewBurn } from '../services/poolService'
import HeroVideo from '../components/HeroVideo.vue'

function createDefaultConfig() {
  return {
    token: '',
    tokenDecimals: 18,
    tokenSymbol: '金狗人生',
    tokenPrice: '--',
    accToken: '--',
    totalReward: '--',
    todayAccToken: '--',
    todayReward: '--',
    showMinAmount: '--',
    rewardRate: 0,
  }
}

function createDefaultUser() {
  return {
    showTokenBalance: '--',
    tokenBalance: null,
    tokenAllowance: null,
    binderLen: '--',
    cooperationReward: '--',
    maxReward: '--',
    remainReward: '--',
    pendingReward: '0.0000',
    teamNum: '--',
    teamAmount: '--',
    isActive: false,
  }
}

export default {
  name: 'BurnView',
  components: {
    HeroVideo,
  },
  data() {
    return {
      ui: DAPP_CONFIG.mining,
      video: DAPP_CONFIG.video,
      chainSymbol: CHAIN_SYMBOL,
      configInfo: createDefaultConfig(),
      userInfo: createDefaultUser(),
      account: '',
      chainId: null,
      inviteLink: '',
      inputAmount: '',
      showTokenOut: '--',
      rewardOut: '--',
      previewErrorText: '',
      burnLoading: false,
      claimLoading: false,
      refreshDataTimer: null,
    }
  },
  mounted() {
    WalletState.onStateChanged(this.handleWalletChanged)
    this.handleWalletChanged({ ...WalletState.wallet })
    this.refreshDataTimer = setInterval(() => {
      this.getInfo()
    }, 15000)
  },
  beforeDestroy() {
    clearInterval(this.refreshDataTimer)
    WalletState.removeListener(this.handleWalletChanged)
  },
  computed: {
    displayTokenBalance() {
      return this.account ? `${this.userInfo.showTokenBalance} ${this.configInfo.tokenSymbol || '金狗人生'}` : `-- ${this.configInfo.tokenSymbol || '金狗人生'}`
    },
    canShowInviteLink() {
      return !!this.userInfo.isActive
    },
    inviteDisplayText() {
      return (this.canShowInviteLink ? this.inviteLink : '') || this.ui.inviteHint
    },
    copyInviteDisabled() {
      return !this.canShowInviteLink || !this.inviteLink
    },
  },
  methods: {
    getBurnErrorMessage(error) {
      const message = String((error && error.message) || error || '')
      const lower = message.toLowerCase()
      if (lower.includes('execution reverted') || lower.includes('ds-math-sub-underflow') || lower.includes('call revert exception')) {
        return '当前金额无法参与燃烧'
      }
      return message || '当前金额无法参与燃烧'
    },
    normalizeDailyStat(value) {
      if (value === undefined || value === null || value === '' || value === '0' || value === '0.0' || value === '0.00' || value === '0.0000') {
        return '--'
      }
      return value
    },
    toast(message) {
      this.$notify({ type: 'danger', message, duration: 4000 })
    },
    toastSuccess(message) {
      this.$notify({ type: 'success', message, duration: 2500 })
    },
    showLoading(message) {
      this.$toast.loading({ duration: 0, message, forbidClick: true, loadingType: 'spinner' })
    },
    hideLoading() {
      this.$toast.clear()
    },
    async getInfo() {
      try {
        const { configInfo, userInfo } = await fetchBurnData(this.account)
        this.configInfo = configInfo
        this.userInfo = { ...createDefaultUser(), ...userInfo }
        if (this.inputAmount) {
          await this.updatePreview(this.inputAmount)
        }
      } catch (error) {
        this.toast(error.message)
      }
    },
    handleWalletChanged(wallet) {
      this.chainId = wallet.chainId
      this.account = wallet.account || ''
      this.inviteLink = this.account ? getInviteLink(this.account) : ''
      this.getInfo()
    },
    async handleInputValue(event) {
      const value = event.target.value
      this.inputAmount = value
      this.showTokenOut = '--'
      this.rewardOut = '--'
      this.previewErrorText = ''
      if (!value || !this.configInfo.token) {
        return
      }
      await this.updatePreview(value)
    },
    async updatePreview(amount) {
      try {
        const preview = await previewBurn({
          amount,
          rewardRate: this.configInfo.rewardRate,
          tokenDecimals: this.configInfo.tokenDecimals,
        })
        if (this.inputAmount !== amount) {
          return
        }
        this.showTokenOut = preview.showTokenOut
        this.rewardOut = preview.rewardOut
        this.previewErrorText = ''
      } catch (error) {
        this.showTokenOut = '--'
        this.rewardOut = '--'
        this.previewErrorText = this.getBurnErrorMessage(error)
      }
    },
    async claim() {
      let wallet = null
      try {
        wallet = await WalletState.ensureWallet(!this.account)
      } catch (error) {
        this.toast(error.message || '\u8fde\u63a5\u94b1\u5305\u5931\u8d25')
        return
      }
      this.chainId = wallet.chainId
      this.account = wallet.account || ''
      this.inviteLink = this.account ? getInviteLink(this.account) : ''
      if (!this.account) {
        return
      }
      if (Number(this.chainId) !== Number(CHAIN_ID)) {
        this.toast(CHAIN_ERROR_TIP)
        return
      }
      this.showLoading('领取中...')
      this.claimLoading = true
      try {
        const transaction = await claimAction(this.account)
        if (transaction.status) {
          this.toastSuccess('领取成功')
          await this.getInfo()
        } else {
          this.toast('领取失败')
        }
      } catch (error) {
        this.toast(error.message)
      } finally {
        this.hideLoading()
        this.claimLoading = false
      }
    },
    async burn() {
      let wallet = null
      try {
        wallet = await WalletState.ensureWallet(!this.account)
      } catch (error) {
        this.toast(error.message || '\u8fde\u63a5\u94b1\u5305\u5931\u8d25')
        return
      }
      this.chainId = wallet.chainId
      this.account = wallet.account || ''
      this.inviteLink = this.account ? getInviteLink(this.account) : ''
      if (!this.account) {
        return
      }
      if (Number(this.chainId) !== Number(CHAIN_ID)) {
        this.toast(CHAIN_ERROR_TIP)
        return
      }
      if (!this.inputAmount) {
        this.toast('请填写燃烧数量')
        return
      }
      if (!this.configInfo.token) {
        this.toast('请等待获取燃烧信息')
        return
      }
      if (this.previewErrorText) {
        this.toast(this.previewErrorText)
        return
      }
      this.showLoading('燃烧中...')
      this.burnLoading = true
      try {
        const transaction = await burnAction({
          account: this.account,
          inputAmount: this.inputAmount,
          configInfo: this.configInfo,
          userInfo: this.userInfo,
          invitor: getRef(),
        })
        if (transaction.status) {
          this.toastSuccess('燃烧成功')
          this.inputAmount = ''
          this.showTokenOut = '--'
          this.rewardOut = '--'
          this.previewErrorText = ''
          await this.getInfo()
        } else {
          this.toast('燃烧失败')
        }
      } catch (error) {
        this.toast(this.getBurnErrorMessage(error))
      } finally {
        this.hideLoading()
        this.burnLoading = false
      }
    },
    async copyInvite() {
      if (this.copyInviteDisabled) {
        this.toast(this.ui.inviteHint)
        return
      }
      try {
        await copyContent(this.inviteLink)
      } catch (error) {
        // utility handles feedback
      }
    },
  },
}
</script>
